import React from 'react'

import Drafts from './Drafts'
import Threads from './Threads'
import Saved from './Saved'
import Mentions from './Mentions'

const InChatSections = ({ page }) => {
  return (
    <>
      {['drafts', 'scheduled'].includes(page) ? <Drafts page={page} /> : null}
      {page === 'threads' && <Threads />}
      {page === 'mentions' && <Mentions />}
      {page === 'saved' && <Saved />}
    </>
  )
}

export default InChatSections
